import { useEffect } from 'react';
import { fromEvent } from 'rxjs';

export const onResume = fromEvent(window, 'focus');

export function useOnResume(callback, inputs: any[] = []) {
    useEffect(() => {
        const subscription$ = onResume.subscribe(callback);
        return () => subscription$.unsubscribe();
    }, inputs);
}
